const autocompleteModalPlace = {
  site: 'Sites'
};

export default autocompleteModalPlace;
